import withLazyLoading from '../../hoc/withLazyLoading';
import { createCrumbHandle } from '../../utilities/auth';
import { EVERYONE, access, anyOf } from '../../access';
import { USER_CENTER_RULES } from '../../modules/user-center/access';
import { UserCenterIndex } from '../../modules/user-center/components/layout/UserCenterIndex';

const UserCenterLayout = withLazyLoading(() =>
  import('../../modules/user-center/components/layout/UserCenterLayout').then((m) => ({
    default: m.UserCenterLayout,
  })),
);

const PeopleDirectory = withLazyLoading(() =>
  import('../../modules/user-center/components/people/PeopleDirectory').then((m) => ({
    default: m.PeopleDirectory,
  })),
);

const PersonSettingsRoute = withLazyLoading(() =>
  import('../../modules/user-center/components/person/PersonSettingsRoute').then((m) => ({
    default: m.PersonSettingsRoute,
  })),
);

const RolesLibrary = withLazyLoading(() =>
  import('../../modules/user-center/components/library/RolesLibrary').then((m) => ({
    default: m.RolesLibrary,
  })),
);

const PlantsLicences = withLazyLoading(() =>
  import('../../modules/user-center/components/plants/PlantsLicences').then((m) => ({
    default: m.PlantsLicences,
  })),
);

const PlantPeopleRoute = withLazyLoading(() =>
  import('../../modules/user-center/components/plants/PlantPeopleRoute').then((m) => ({
    default: m.PlantPeopleRoute,
  })),
);

const userCenterRoutes = [
  {
    path: '/user-center',
    handle: {
      ...createCrumbHandle('User Center'),
      ...access(anyOf(USER_CENTER_RULES.manageAccess, USER_CENTER_RULES.readPlants)),
    },
    element: <UserCenterLayout />,
    children: [
      { index: true, element: <UserCenterIndex />, handle: access(EVERYONE) },
      {
        path: 'people',
        handle: { ...createCrumbHandle('People'), ...access(USER_CENTER_RULES.manageAccess) },
        element: <PeopleDirectory />,
      },
      {
        path: 'people/:userId',
        handle: { ...createCrumbHandle('Person'), ...access(USER_CENTER_RULES.manageAccess) },
        element: <PersonSettingsRoute />,
      },
      {
        path: 'library',
        handle: { ...createCrumbHandle('Roles & grants'), ...access(USER_CENTER_RULES.manageAccess) },
        element: <RolesLibrary />,
      },
      {
        path: 'plants',
        handle: { ...createCrumbHandle('Plants & modules'), ...access(USER_CENTER_RULES.readPlants) },
        element: <PlantsLicences />,
      },
      {
        path: 'plants/:plantId/people',
        handle: { ...createCrumbHandle('People'), ...access(USER_CENTER_RULES.manageAccess) },
        element: <PlantPeopleRoute />,
      },
    ],
  },
];

export default userCenterRoutes;
